(function () {
  const root = document.querySelector('[data-fb-cart-page]');
  if (!root) return;

  const itemsRoot = root.querySelector('[data-fb-cart-page-items]');
  const subtotalEl = root.querySelector('[data-fb-cart-page-subtotal]');
  const countEl = root.querySelector('.fb-cart-page__count');
  const titleEl = root.querySelector('.fb-cart-page__title');
  const headerCount = document.querySelector('[data-fb-header-cart-count]');
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  let isLoading = false;

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    if (moneyFormat.includes('{{amount_with_comma_separator}}')) {
      return moneyFormat.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }
    if (moneyFormat.includes('{{amount_no_decimals}}')) {
      return moneyFormat.replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
    }
    if (moneyFormat.includes('{{amount}}')) {
      return moneyFormat.replace('{{amount}}', amount);
    }
    return `$${amount}`;
  };

  const setHeaderCount = (count) => {
    if (!headerCount) return;
    if (count > 0) {
      headerCount.textContent = String(count);
      headerCount.hidden = false;
    } else {
      headerCount.textContent = '';
      headerCount.hidden = true;
    }
  };

  const updateSummary = (cart) => {
    const count = cart.item_count || 0;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price || 0);
    if (countEl) countEl.textContent = count > 0 ? `(${count})` : '';
    setHeaderCount(count);
    window.FbCart?.refresh?.().catch(() => {});
  };

  const changeLine = async (key, quantity) => {
    if (isLoading) return;
    isLoading = true;
    root.classList.add('is-updating');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      const item = cart.items.find((entry) => entry.key === key);
      const lineEl = itemsRoot?.querySelector(`[data-line-key="${key}"]`);

      if (quantity === 0 || !item) {
        lineEl?.remove();
      } else if (lineEl) {
        const qtyEl = lineEl.querySelector('[data-fb-cart-qty]');
        const priceEl = lineEl.querySelector('[data-fb-cart-line-price]');
        if (qtyEl) qtyEl.textContent = String(item.quantity);
        if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
      }

      updateSummary(cart);
    } catch (error) {
      window.location.reload();
    } finally {
      isLoading = false;
      root.classList.remove('is-updating');
    }
  };

  itemsRoot?.addEventListener('click', (event) => {
    const item = event.target.closest('[data-line-key]');
    if (!item) return;

    const key = item.dataset.lineKey;
    const qtyEl = item.querySelector('[data-fb-cart-qty]');
    const currentQty = parseInt(qtyEl?.textContent, 10) || 0;

    if (event.target.closest('[data-fb-cart-qty-minus]')) {
      changeLine(key, Math.max(0, currentQty - 1));
    } else if (event.target.closest('[data-fb-cart-qty-plus]')) {
      changeLine(key, currentQty + 1);
    } else if (event.target.closest('[data-fb-cart-remove]')) {
      changeLine(key, 0);
    }
  });
})();
